import React from 'react';
import { Grid, Button, Box } from '@mui/material';
import { useFormikContext } from 'formik';

export default function ResourceSelectField(props) {
    const { submitForm, setFieldValue } = useFormikContext();
    const [pressed, setPressed] = React.useState(false);

    React.useEffect(() => {
        pressed && submitForm()
    }, [pressed, submitForm])

    function changeValue(resource) {
        setFieldValue(props.name, resource);
        setPressed(true);
    }

    return (
        <Box mt={2} mb={2}>
            {/* <Grid container spacing={3} justify="center"> */}
            <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                <Grid item>
                    <Button variant="contained" sx={{color:"white"}} size="large" disableFocusRipple fullWidth={true} onClick={() => { changeValue("Rodado") }}>
                        Rodados
                    </Button>
                </Grid>
                <Grid item>
                    <Button variant="contained" sx={{color:"white"}} size="large" disableFocusRipple fullWidth={true} onClick={() => { changeValue("Inmueble") }}>
                        Inmuebles
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
